// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Buefy from 'buefy'
import App from './App.vue'
import router from './router'
import { humanize } from './lib/utils/string'
import Fields from './components/Projects/Form/Fields'

import 'buefy/dist/buefy.css'
Vue.use(Buefy, { defaultIconPack: 'fa' })
Vue.component('fields', Fields)
Vue.config.productionTip = false
Vue.filter('humanize', humanize)

new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
})



// WEBPACK FOOTER //
// ./src/main.js